import { authActionTypes } from "../constants/authActionTypes";
import { meetingsActionTypes } from "../constants/meetingsActionTypes";

const initialState = {
    meetings: [],
    calendarMeetings: [],
    upcomingCalendarMeetings: [],
    calendarBotMeetings: [],
}
export const meetingsReducer = (state = initialState, action) => {
    console.log("meetingsReducer=======>", action)
    switch (action.type) {
        case meetingsActionTypes.SET_MEETINGS:return {...state,meetings:action.payload}
        case meetingsActionTypes.SET_CALENDAR_MEETINGS:return {...state,calendarMeetings:action.payload}
        case meetingsActionTypes.SET_UPCOMING_CALENDAR_MEETINGS:return {...state,upcomingCalendarMeetings:action.payload}
        case meetingsActionTypes.SET_CALENDAR_BOT_MEETINGS:return {...state,calendarBotMeetings:action.payload}
        case authActionTypes.LOGOUT: return initialState
        default: return state;
    }
}